import * as React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@cc/react-components";
import { TFunction } from "i18next";

export interface Props extends React.HTMLAttributes<HTMLElement> {
  type: string;
}

const ContactTypeIcon = ({ type }: Props) => {
  const [t] = useTranslation();
  return renderLogo(type, t);
};

const renderLogo = (type: string, t: TFunction) => {
  switch (type) {
    case "REASON":
      return <>R</>;
    case "EVALUATION":
      return <>E</>;
    case "OBJECTIVE":
      return <>O</>;
    case "SUBJECTIVE":
      return <>S</>;
    case "TREATMENT":
      return <>{t("subcontactIcon.Treatment")}</>;
    case "PLANNING":
      return <>P</>;
    case "Episode":
      return <Icon type="care-element" />;
    case "MedicationEntry":
      return <Icon type="medication" />;
    case "ParameterGroupEntry":
      return <Icon type="parameters" />;
    case "SickLeave":
    case "Letter":
      return <Icon type="document" />;
    case "PlannedItem":
      return <Icon type="planning" />;
    case "Vaccination":
      return <Icon type="vaccination" />;
    case "Treatment":
      return <Icon type="treatments" />;
    case "Prescription":
      return <Icon type="prescription" />;
    default:
      return <></>;
  }
};

export default ContactTypeIcon;
